import { render, staticRenderFns } from "./DetailsSideBar.vue?vue&type=template&id=14ee4b82&scoped=true&"
import script from "./DetailsSideBar.vue?vue&type=script&lang=js&"
export * from "./DetailsSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSideBar.vue?vue&type=style&index=0&id=14ee4b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee4b82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VListItem,VNavigationDrawer,VSpacer})
